
if (!customElements.get('product-sticky-add-to-cart')) {
  class TG_ProductStickyAddToCart extends HTMLElement {
    constructor() {
      super();
      this.sectionEl = document.querySelector('section-product');
      this.footerEl = document.querySelector('footer');
      this._onScroll = this._onScroll.bind(this);
    }

    connectedCallback() {
      this.delegateElement = new themegoal.libs.Delegate(this);
      this.delegateElement.on('click', '[data-action="sticky-add-to-cart"]', this._addToCart.bind(this));

      if (this.sectionEl) {
        window.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onScroll, { passive: true });
        this._onScroll();
      }
    }

    disconnectedCallback(){
      if(this.delegateElement)this.delegateElement.destroy();
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onScroll);
    }

    _onScroll(){
      if(!this.sectionEl) return;
      var sectionBottom = this.sectionEl.getBoundingClientRect().bottom;
      var pastSection = sectionBottom < 0;
      var footerInView = this.footerEl ? this.footerEl.getBoundingClientRect().top < window.innerHeight : false;
      this.classList.toggle('Visible', pastSection && !footerInView);
    }

    _addToCart(event) {
      let _this = this;
  
      event.preventDefault(); 
  
      let formElement = this.querySelector('form.ProductStickyAddToCartForm');
  
      let addToCartButton = this.querySelector('.ProductStickyAddToCartForm__AddToCart');
  
      addToCartButton.setAttribute('disabled', 'disabled');
      document.dispatchEvent(new CustomEvent('theme:loading:start'));
  
      fetch(window.routes.cartAddUrl + '.js', {
        body: JSON.stringify(themegoal.components.Form.serialize(formElement)),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest' 
        }
      }).then(function (response) {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
  
        if (response.ok) {
          if (window.theme.cartType == "page") {
            window.location.href = window.routes.cartUrl;
            // return; 
          }else{
            addToCartButton.removeAttribute('disabled');
            response.json().then(function (data) {
              _this.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                  variant: _this.currentVariant,
                  quantity: parseInt(_this.querySelector('[name="quantity"]').value),
                  cartItemKey: data.key
                }
              }));
            });
          }
        } else {
          response.json().then(function (content) {
            var errorMessageElement = document.createElement('div');
            errorMessageElement.className = 'Alert Alert--danger';
            if (typeof content['description'] === 'object') {
              errorMessageElement.innerHTML = content['message'];
            }else{
              errorMessageElement.innerHTML = content['description'];
            }
            addToCartButton.removeAttribute('disabled');
            addToCartButton.insertAdjacentElement('beforeBegin', errorMessageElement);
            setTimeout(function () {
              errorMessageElement.remove();
            }, 8000);
          });
        }
      });
  
      event.preventDefault();
    }
  }
  
  customElements.define('product-sticky-add-to-cart', TG_ProductStickyAddToCart);
}